import { useCallback, useState } from 'react';

export function useFileDeleteHandler(deleteFile: (fileId: number) => Promise<unknown>) {
  const [deletingIds, setDeletingIds] = useState<Set<number>>(new Set());

  const handleDelete = useCallback(
    async (fileId: number) => {
      setDeletingIds((prev) => new Set(prev).add(fileId));
      try {
        await deleteFile(fileId);
      } catch (error) {
        console.error('Failed to delete file:', error);
      } finally {
        setDeletingIds((prev) => {
          const next = new Set(prev);
          next.delete(fileId);
          return next;
        });
      }
    },
    [deleteFile]
  );

  return { deletingIds, handleDelete };
}
